import { component as defineComponent } from 'flightjs';

export default defineComponent(function () {

    this.attributes({
        spinner: '[data-listings-summary-spinner]',
        message: '[data-listings-summary-message]'
    });

    this.after('initialize', function () {
        this.on(document, 'dataContestsLoaded', this.updateResultMessage);
    });

    this.updateResultMessage = function(e, data) {
        var message = $(data).find('#results-message');

        if (message.length) {
            this.select('message').html(message.html());
        }
    };

});



// WEBPACK FOOTER //
// ./src/web/js/browse/ui/listings-summary.js